import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ea1a12c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "padding-16 list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "title"
};
import ModuleCard from "@/views/college/components/ModuleCard.vue";
import { useRouter } from "vue-router";
import { College } from "@/api/college";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialTopics',
  setup(__props) {
    const list = ref([]);
    const getList = async () => {
      const res = await College.SpecialList();
      list.value = res.data;
    };
    getList();
    const router = useRouter();
    const toZhuanTi = val => {
      router.push({
        name: 'zhuanti',
        params: {
          topicId: val.id
        },
        query: {
          name: val.name
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return list.value.length ? (_openBlock(), _createBlock(ModuleCard, {
        key: 0,
        title: "专题介绍"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            onClick: $event => toZhuanTi(item),
            class: "special"
          }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1), _createVNode(_component_el_image, {
            style: {
              "width": "100%",
              "height": "100%"
            },
            src: item.coverId,
            fit: "cover"
          }, null, 8, ["src"])], 8, _hoisted_2);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});